import { createAsyncThunk } from '@reduxjs/toolkit'
import { EarnsDetail, getEarnsDetail } from 'api/v1/earns/detail'
import { getEarnsLuckyList } from 'api/v1/earns/luckyList'
import { getEarnsTodayTrade } from 'api/v1/earns/today'
import { RootState } from 'store'
import { Address } from 'types'
import dayjs from 'dayjs'

export const fetchEarnsDetailAction = createAsyncThunk<EarnsDetail>(
  'earns/fetchEarnsDetailAction',
  async () => {
    const { data } = await getEarnsDetail()

    const { dailyTaskEntities = [], dailyHistoryList = [] } = data ?? {}

    data.dailyTaskEntities = dailyTaskEntities.map((v) => {
      const time = dayjs()
        .utc()
        .year(Number(String(v.period).substring(0, 4)))
        .month(Number(String(v.period).substring(4, 6)) - 1)
        .date(Number(String(v.period).substring(6)))
        .startOf('days')
        .valueOf()

      const history = dailyHistoryList.find(
        (v) =>
          dayjs(v.createdAt).format('YYYYMMDD') ===
          dayjs(time).format('YYYYMMDD'),
      )
      return {
        ...v,
        time,
        completed: !!history,
        history: history ?? null,
        period: String(v.period),
      }
    })

    return data
  },
)

export const fetchEarnsTodayTradeAction = createAsyncThunk<
  number,
  void,
  {
    state: RootState
  }
>('earns/fetchEarnsTodayTradeAction', async (_, { getState }) => {
  const { account } = getState()
  const { accountInfo } = account ?? {}
  const { userId } = accountInfo ?? {}

  if (!userId) return 0

  const response = await getEarnsTodayTrade()

  const { data } = response
  if (!data || !data[userId]) return 0

  return data[userId]
})

export const fetchEarnsLuckyListAction = createAsyncThunk<Address[]>(
  'earns/fetchEarnsLuckyListAction',
  async () => {
    const response = await getEarnsLuckyList()
    return response.data
  },
)
